import { EventTypeIdentifier } from './eventTypeIdentifier';

// those colors are used in the map legend as enforcement zones colors and in KLM parser

export const EventTypePalette: Record<EventTypeIdentifier | string, string> = {
  [EventTypeIdentifier.DOUBLE_PARKED]: '#0000ff',
  [EventTypeIdentifier.BUS_LANE]: '#ff0000',
  [EventTypeIdentifier.BUS_LANE_MOVING]: '#ff0000',
  [EventTypeIdentifier.BUS_LANE_PARKING]: '#ff0000',
  [EventTypeIdentifier.BIKE_LANE]: '#90ee90',
  [EventTypeIdentifier.BUS_STOP_PARKING]: '#d72638',
  [EventTypeIdentifier.BUS_STOP]: '#00ffff',
  [EventTypeIdentifier.DOUBLE_YELLOW]: '#ffff00',
  [EventTypeIdentifier.NO_STOPPING]: '#ffa500',
  [EventTypeIdentifier.NO_STOPPING_TEST]: '#ff00ff',
  [EventTypeIdentifier.ROADWORKS]: '#9999ff',
  [EventTypeIdentifier.STREETCAR_BLOCKED]: '#2d5016',
  [EventTypeIdentifier.STREETCAR_STOP]: '#9d4edd',
  [EventTypeIdentifier.OUTSIDE_ROUTE]: '#eae5f6ff',
  [EventTypeIdentifier.TEST]: '#ff1493',
  [EventTypeIdentifier.METER_PARKING]: '#ff00ff',
  [EventTypeIdentifier.NO_PARKING]: '#7293A0',
  ROADWORKS_PERMIT: '#ff8c00',
} as const;
